import { useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import { Row, Card, Button, message, Form } from "antd";
import { Input } from "antd";
import { useHistory, useLocation } from "react-router-dom";
import jwtDecode from "jwt-decode";
import { createActivityType } from "../utils/activityTypeApi";

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
  },
};
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 16,
      offset: 8,
    },
  },
};

function AddActivityType() {
  const history = useHistory();
  const location = useLocation();

  const [token, setToken] = useState(localStorage.getItem("token"));
  const [messageApi, contextHolder] = message.useMessage();
  const [activityName, setActivityName] = useState();

  const success = () => {
    messageApi.open({
      type: "success",
      content: "Activity type added successfully",
    });
  };
  const error = (e) => {
    messageApi.open({
      type: "error",
      content: `Activity type was not added. Please try again later. (${e})`,
    });
  };

  const [form] = Form.useForm();
  const onFinish = (values) => {
    console.log("Received values of form: ", values);
  };

  const addActivityType = async () => {
    if (activityName) {
      try {
        await createActivityType({
          id: uuidv4(),
          activityName: activityName,
        });
        success();
      } catch (e) {
        console.log(e);
        error(e?.response?.data?.reason || e.message);
      }
    }
  };

  useEffect(() => {
    let currentDate = new Date();
    setToken(localStorage.getItem("token"));
    if (
      (token && jwtDecode(token).exp * 1000 < currentDate.getTime()) ||
      token === null
    ) {
      history.push("/sign-in");
    } else {
      history.push(location.pathname);
    }
  }, [token]);

  return (
    <>
      {contextHolder}

      <Card
        bordered={false}
        className="header-solid mb-24"
        title={
          <>
            <h6 className="font-semibold">Add Activity Type</h6>
            <p>Add activity type information below</p>
          </>
        }
      >
        <Row
          style={{
            marginLeft: "20px",
            marginRight: "20px",
          }}
        >
          <Form
            {...formItemLayout}
            form={form}
            name="register"
            onFinish={onFinish}
            style={{
              width: "80%",
            }}
            scrollToFirstError
          >
            <Form.Item
              name="activityName"
              label="Activity Name"
              tooltip="Please provide an activity name"
              rules={[
                {
                  required: true,
                  message: "Please input the activity name!",
                  whitespace: true,
                },
              ]}
            >
              <Input
                value={activityName}
                onChange={(e) => setActivityName(e.target.value)}
              />
            </Form.Item>

            <Form.Item {...tailFormItemLayout}>
              <Button
                type="secondary"
                className="tag-primary"
                htmlType="submit"
                onClick={() => addActivityType()}
              >
                Create Activity Type
              </Button>
            </Form.Item>
          </Form>
        </Row>
      </Card>
    </>
  );
}

export default AddActivityType;
